import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import UtradeHubLoginPopup from './UtradeHubLoginPopup'
import { regisActions, alertActions } from '../../../store/actions'
import history from '../../../route/history'
import $ from 'jquery'

const Join = (props) => {
  const [state, setState] = useState({
    isShowLogin: false, //uth 로그인 정보 입력창
    isType: '', //가입구분
  })

  useEffect(() => {
    $('.join-intro button').on('click', function () {
      $(this).addClass('on').siblings('button').removeClass('on')
    })
  }, [])

  useEffect(() => {

    // KCL : B552693 KATRI : CUS0004 KTC : B552753 KTR : B552691
    if(props.match.params?.from==="B552693" || props.match.params?.from==="CUS0004" || props.match.params?.from==="B552691" || props.match.params?.from==="B552753"){
      props.setJoinFlag('corp')

      setState({ ...state.isShowLogin, isShowLogin: false })
      history.replace({
        pathname: '/regis',
        state:{ bplcCd: props.match.params?.from }
      })
    }else if(props.match.params?.from != undefined){
      history.replace({ pathname: '/' })
    }
  }, [])

  useEffect(() => {
    props.auth?.isLoggedIn &&
      props.success({
        message: '회원가입은 로그아웃 후 이용해주시길 바랍니다.',
        params: {
          type: 'SUCCESS',
          callback: () => {
            window.history.back()
          },
        },
      })
  }, [props.auth?.isLoggedIn])

  const goNext = () => {
    let type = state.isType
    if (type === 'user' || type === 'corp') {
      props.setJoinFlag(type)
      setState({ ...state.isShowLogin, isShowLogin: false })
      history.replace({ pathname: '/regis' })
    } else if (type === 'uth') {
      props.setJoinFlag(type)
      setState({ ...state.isShowLogin, isShowLogin: true })
    }
  }

  const setIsType = (isType) => {
    setState({ ...state, isType })
  }

  const cancel = () => {
    setState({ ...state.isShowLogin, isShowLogin: false })

    let join = document.getElementsByClassName('join-user')
    for (let i = 0; i < join.length; i++) {
      join[i].classList.remove('on')
    }
  }

  return (
    <React.Fragment>
      {/* <Alert /> */}
      <div id="contents">
        <div className="content-header type2">
          {/* mobile 뒤로가기 버튼 */}
          <a
            onClick={(e) => {
              e.preventDefault()
              window.history.back()
            }}
            className="page-prev"
          >
            뒤로이동
          </a>
          <h2>회원가입</h2>
          <div className="breadcrumb">
            <span>Home</span>
            <em>회원가입</em>
          </div>
        </div>

        <div className="join-wrap">
          <div className="join-intro">
            {/*<button className="join-user cursor" style={{ backgroundImage: 'url(./images/sub/ico_join1.png)' }} onClick={() => setIsType('user')}>*/}
            {/*  개인회원*/}
            {/*</button>*/}
            <button className="join-user cursor" style={{paddingTop:0, background:"none"}} onClick={() => setIsType('corp')}>
              <img src={require('../../../assets/images/sub/ico_join3.png')} style={{zIndex:99999}}/>
              <br /><br /><br />
              기업회원
              {/*<p style={{fontSize:"13px", color:"cornflowerblue"}}>개인사업자 또는 법인사업자의 경우 </p>*/}
              {/*<p style={{fontSize:"13px", color:"cornflowerblue"}}><u>기업회원</u>으로 가입하여 주시기 바랍니다.</p>*/}
            </button>
            <button className="join-user cursor" style={{ paddingTop:0, background:"none" }} onClick={() => setIsType('uth')}>
              <img src={require('../../../assets/images/sub/ico_join2.png')} style={{zIndex:99999}}/>
              <br /><br /><br />
              회원정보로 가입
            </button>
          </div>
          <div className="btn-block center" style={{ padding:"100px" }}>
            <button onClick={goNext} className="btn-primary lg modal-popup cursor">
              다음 단계로
            </button>
          </div>

        </div>
      </div>
      {state.isShowLogin === true && (
        <UtradeHubLoginPopup
          isShowLogin={state.isShowLogin}
          // onChange={() => setState({...state.isShowLogin, isShowLogin: false})}
          onChange={cancel}
        />
      )}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  }
}

const actionCreators = {
  setJoinFlag: regisActions.setJoinFlag,
  success: alertActions.success,
}

export default connect(mapStateToProps, actionCreators)(Join)
